<template>
  <v-app id="inspire">
    <!-- Navigation Drawer: Visible on small screens only -->
    <v-navigation-drawer
      v-if="$vuetify.breakpoint.smAndDown"
      v-model="drawer"
      app
      temporary
      class="mobile-drawer full-width-drawer"
      transition="slide-x-reverse-transition"
      width="100%"
    >
      <v-list nav dense class="mt-16 pt-12">
        <v-list-item @click="$router.push('/home')" class="nav-item">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="white--text">Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push('/aboutus')" class="nav-item">
          <v-list-item-icon>
            <v-icon>mdi-information-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="white--text">About Us</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$router.push('/sactin-clients')" class="nav-item">
          <v-list-item-icon>
            <v-icon>mdi-information-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="white--text">Clients</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-subheader class="section-title">Our Products</v-subheader> -->
        <v-list-group no-action>
          <!-- Left icon slot -->
          <template v-slot:prependIcon>
            <v-icon color="white">mdi-package-variant</v-icon>
          </template>

          <!-- Title -->
          <template v-slot:activator>
            <v-list-item-title class="white--text">Our Products</v-list-item-title>
          </template>

          <!-- Right expand/collapse icon -->
          <template v-slot:appendIcon>
            <v-icon color="white">mdi-chevron-down</v-icon>
          </template>

          <!-- Submenu items -->
          <!-- <v-list-item @click="$router.push('/sactin-erp')" class="submenu-item">
            <v-list-item-title class="white--text">ERP</v-list-item-title>
          </v-list-item>

          <v-list-item
            @click="$router.push('/sactin-interactive-panel')"
            class="submenu-item"
          >
            <v-list-item-title class="white--text">Interactive Panel</v-list-item-title>
          </v-list-item> -->

          <v-list class="rounded-xl py-2 dark-menu" elevation="10">
            <!-- <v-subheader class="section-title">Our Products</v-subheader> -->
            <v-list-group no-action>
              <!-- Title -->
              <template v-slot:activator>
                <v-list-item
                  v-bind="attrs"
                  v-on="on"
                  class="hover-list-item"
                  @click="$router.push('/sactin-interactive-panel')"
                >
                  <v-list-item-title class="white--text"
                    >Sactin Interactive Panel</v-list-item-title
                  >
                </v-list-item>
              </template>

              <!-- Right expand/collapse icon -->
              <template v-slot:appendIcon>
                <v-icon color="white">mdi-chevron-down</v-icon>
              </template>

              <v-list-item
                @click="$router.push('/65-inch-sactin-interactive-panel')"
                class="hover-sub-item"
              >
                <v-list-item-title>65 inch Sactin Interactive Panel</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/75-inch-sactin-interactive-panel')"
                class="hover-sub-item"
              >
                <v-list-item-title>75 inch Sactin Interactive Panel</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/85-inch-sactin-interactive-panel')"
                class="hover-sub-item"
              >
                <v-list-item-title>85 inch Sactin Interactive Panel</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/98-inch-sactin-interactive-panel')"
                class="hover-sub-item"
              >
                <v-list-item-title>98 inch Sactin Interactive Panel</v-list-item-title>
              </v-list-item>
            </v-list-group>

            <!-- Other menus -->
            <v-list-item @click="$router.push('/sactin-erp')" class="hover-list-item">
              <v-list-item-title>Sactin ERP</v-list-item-title>
            </v-list-item>
            <v-list-item
              @click="$router.push('/sactin-gps-tracking')"
              class="hover-list-item"
            >
              <v-list-item-title>Sactin GPS Tracking System</v-list-item-title>
            </v-list-item>
            <v-list-item
              @click="$router.push('/sactin-mobile-app')"
              class="hover-list-item"
            >
              <v-list-item-title>Mobile App</v-list-item-title>
            </v-list-item>

            <v-list-item
              @click="$router.push('/sactin-biometric-system')"
              class="hover-list-item"
            >
              <v-list-item-title>Sactin Biometric System</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-list-group>

        <v-list-item @click="$router.push('/ourservices')" class="nav-item">
          <v-list-item-icon>
            <v-icon>mdi-fingerprint</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="white--text">Our Services</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push('/contactus')" class="nav-item">
          <v-list-item-icon>
            <v-icon>mdi-phone</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="white--text">Contact Us</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- App Bar -->
    <v-app-bar fixed flat class="mobile-appbar appbarspldd elevation-0">
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.smAndDown"
        @click="drawer = !drawer"
        class="white--text mr-4"
      />
      <img src="@/assets/sactin-logo.jpg" alt="logo" class="appbar-logo" />

      <!-- <v-toolbar-title class="white--text pl-0">SACTIN</v-toolbar-title> -->

      <!-- <v-app-bar-nav-icon
  v-if="$vuetify.breakpoint.smAndDown"
  @click="drawer = !drawer"
  class="white--text"
></v-app-bar-nav-icon>


<div 
  class="logo-container"
  @click="$router.push('/home')"
>
  <img 
    src="@/assets/sactin.png" 
    alt="SACTIN Logo" 
    class="logo-img" 
  />
</div>

<v-toolbar-title 
  class="white--text pl-0 clickable-title"
  @click="$router.push('/home')"
>
  SACTIN
</v-toolbar-title> -->

      <!-- Menu with Submenu -->
      <v-spacer></v-spacer>

      <!-- start system menu -->

      <v-menu v-if="$vuetify.breakpoint.mdAndUp" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
            class="white--text"
            @click="$router.push('/home')"
            >Home</v-btn
          >
        </template>
      </v-menu>
      <v-menu v-if="$vuetify.breakpoint.mdAndUp" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
            class="white--text"
            @click="$router.push(`/aboutus`)"
            >About Us</v-btn
          >
        </template>
      </v-menu>
      <v-menu v-if="$vuetify.breakpoint.mdAndUp" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
            class="white--text"
            @click="$router.push(`/sactin-clients`)"
            >Clients</v-btn
          >
        </template>
      </v-menu>
      <v-menu v-if="$vuetify.breakpoint.mdAndUp" offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
            class="white--text text-capitalize font-weight-medium px-4 modern-btn"
          >
            Our Products
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>

        <v-list class="rounded-xl py-2 dark-menu" elevation="10">
          <v-list-item @click="$router.push('/sactin-erp')" class="hover-list-item">
            <v-list-item-title>Sactin ERP</v-list-item-title>
          </v-list-item>
          <!-- iOS with submenu -->
          <v-menu offset-x open-on-hover transition="slide-x-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-list-item
                v-bind="attrs"
                v-on="on"
                class="hover-list-item"
                @click="$router.push('/sactin-interactive-panel')"
              >
                <v-list-item-title>Sactin Interactive Panel</v-list-item-title>
                <v-spacer></v-spacer>
                <v-icon small>mdi-chevron-right</v-icon>
              </v-list-item>
            </template>

            <v-list class="rounded-xl py-1 dark-submenu" elevation="8">
              <v-list-item
                @click="$router.push('/65-inch-sactin-interactive-panel')"
                class="hover-sub-item"
              >
                <v-list-item-title>65 inch Sactin Interactive Panel</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/75-inch-sactin-interactive-panel')"
                class="hover-sub-item"
              >
                <v-list-item-title>75 inch Sactin Interactive Panel</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/85-inch-sactin-interactive-panel')"
                class="hover-sub-item"
              >
                <v-list-item-title>85 inch Sactin Interactive Panel</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="$router.push('/98-inch-sactin-interactive-panel')"
                class="hover-sub-item"
              >
                <v-list-item-title>98 inch Sactin Interactive Panel</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- Other menus -->

          <v-list-item
            @click="$router.push('/sactin-gps-tracking')"
            class="hover-list-item"
          >
            <v-list-item-title>Sactin GPS Tracking System</v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="$router.push('/sactin-mobile-app')"
            class="hover-list-item"
          >
            <v-list-item-title>Mobile App</v-list-item-title>
          </v-list-item>

          <v-list-item
            @click="$router.push('/sactin-biometric-system')"
            class="hover-list-item"
          >
            <v-list-item-title>Sactin Biometric System</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu v-if="$vuetify.breakpoint.mdAndUp" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
            class="white--text"
            @click="$router.push(`/ourservices`)"
            >Our Services</v-btn
          >
        </template>
      </v-menu>

      <v-menu v-if="$vuetify.breakpoint.mdAndUp" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
            class="white--text"
            @click="$router.push(`/contactus`)"
            >Contact Us</v-btn
          >
        </template>
      </v-menu>

      <!-- 
      <v-menu v-if="$vuetify.breakpoint.mdAndUp" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on" class="white--text" 
            >Interactive Panels</v-btn
          >
        </template>
        <v-list>
          <v-list-item @click="menuAction('Panel Type 1')"
            >Panel Type 1</v-list-item
          >
          <v-list-item @click="menuAction('Panel Type 2')"
            >Panel Type 2</v-list-item
          >
          <v-list-item @click="menuAction('Panel Type 3')"
            >Panel Type 3</v-list-item
          >
        </v-list>
      </v-menu> -->

      <!-- <v-menu v-if="$vuetify.breakpoint.mdAndUp" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on" class="white--text">ERP</v-btn>
        </template>
        <v-list>
          <v-list-item @click="$router.push('/websiteerp')">Module 1</v-list-item>


          <v-list-item @click="menuAction('Module 2')">Module 2</v-list-item>
          <v-list-item @click="menuAction('Module 3')">Module 3</v-list-item>
        </v-list>
      </v-menu> -->

      <!-- <v-menu v-if="$vuetify.breakpoint.mdAndUp" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
            class="white--text"
            @click="$router.push('/websitegpstracking')"
            >GPS Tracking</v-btn
          >
        </template>
      </v-menu> -->

      <!-- <v-menu v-if="$vuetify.breakpoint.mdAndUp" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on" class="white--text"  
            >GPS Tracking</v-btn
          >
        </template>
        <v-list>
          <v-list-item @click="menuAction('Live Tracking')"
            >Live Tracking</v-list-item
          >
          <v-list-item @click="menuAction('Reports')">Reports</v-list-item>
          <v-list-item @click="menuAction('Alerts')">Alerts</v-list-item>
        </v-list>
      </v-menu> -->

      <!-- <v-menu v-if="$vuetify.breakpoint.mdAndUp" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on" class="white--text">Contact Us</v-btn>
        </template>
        <v-list>
          <v-list-item @click="menuAction('Email')">Email</v-list-item>
          <v-list-item @click="menuAction('Phone')">Phone</v-list-item>
          <v-list-item @click="menuAction('Location')">Location</v-list-item>
        </v-list>
      </v-menu> -->

      <!-- end system menu -->

      <v-spacer></v-spacer>
    </v-app-bar>

    <!-- Main content for small screens -->
    <!-- <v-main class="d-xl-none d-sm-flex" style="background: #82b1ff1a"> -->
    <v-main class="d-xl-none d-sm-flex pa-0 ma-0" style="background: #82b1ff1a">
      <v-container fluid class="pa-0 ma-0">
        <v-row>
          <v-col>
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <!-- Main content for large screens -->
    <!-- <v-main class="px-16 py-6 d-none d-xl-flex" style="background: #82b1ff1a"> -->
    <v-main class="pa-0 d-none d-xl-flex ma-0" style="background: #82b1ff1a">
      <v-container fluid class="pa-0 ma-0">
        <v-row>
          <v-col>
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    drawer: null,
  }),

  mounted() {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 50) {
        document.body.classList.add("scrolled");
      } else {
        document.body.classList.remove("scrolled");
      }
    });
  },
};
</script>

<style scoped>
/* .appbarspldd {
 
  background: linear-gradient(
    90deg,
    rgba(3, 41, 99, 1) 0%,
    rgba(29, 88, 177, 1) 35%,
    rgba(4, 52, 124, 1) 100%
  );
} */
@media only screen and (min-width: 1280px) {
  .appbarspldd {
    left: 0 !important;
  }
  .topnavsidebar {
    top: 65px !important;
  }
}

.v-table {
  height: 92%;
  overflow-y: auto;
}
.wdk {
  width: 20px;
}
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.27;
  border-radius: 20px !important;
  background: linear-gradient(0deg, rgba(34, 193, 195, 1) 0%, rgba(45, 122, 253, 1) 100%);
}
.v-icon.v-icon {
  font-size: 19px !important;
}
::v-deep .theme--light.v-list-group__header i.fas.fa-chevron-down,
::v-deep .theme--light.v-list-group__header i.fas.fa-chevron-up {
  font-size: 12px !important;
}
::v-deep .v-sheet.v-app-bar.v-toolbar:not(.v-sheet--outlined) {
  height: 96px !important;
}
::v-deep .v-toolbar__content,
.v-toolbar__extension {
  height: 98px !important;
}
/* .appbarspldd {
  background-color: transparent !important;
  box-shadow: none !important; 
}

::v-deep .v-sheet.v-app-bar.v-toolbar:not(.v-sheet--outlined) {
  background-color: transparent !important;
  box-shadow: none !important;
}

::v-deep .v-toolbar__content, 
::v-deep .v-toolbar__extension {
  background-color: transparent !important;
} */

/* .appbarspldd {
  background-color: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(8px);
} */

.appbarspldd {
  background-color: transparent !important;
  box-shadow: none !important;
  z-index: 10; /* Stay above banner */
  transition: background-color 0.3s ease;
}

.banner {
  height: 100vh;
  position: relative;
  margin-top: -96px; /* same as app-bar height */
}

/* Background color when scrolling */
.scrolled .appbarspldd {
  background-color: rgba(0, 0, 0, 0.8) !important;
  color: white;
}
.logo-container {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.logo-img {
  height: 40px; /* fit mobile height */
  max-width: 100px;
  object-fit: contain;
}

.clickable-title {
  cursor: pointer;
}

@media (max-width: 1279px) {
  .topnavsidebar {
    position: fixed !important;
    top: 96px !important; /* same height as your app bar */
    height: calc(100% - 96px) !important;
    z-index: 1000 !important;
  }

  .appbarspldd {
    position: fixed !important;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1100 !important; /* stays above the drawer */
  }
}

/* menu animation start  */
.dark-menu,
.dark-submenu {
  background: #000000;
  color: #ffffff;
  animation: fadeIn 0.3s ease-in-out;
}

.modern-btn {
  transition: all 0.3s ease;
}
.modern-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.hover-list-item,
.hover-sub-item {
  color: #ffffff !important;
  transition: background 0.3s, transform 0.2s;
}
.hover-list-item:hover,
.hover-sub-item:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateX(5px);
}

.v-icon {
  color: #ffffff !important;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* start mobile view nav */
.mobile-drawer {
  background: rgba(20, 20, 20, 0.9);
  backdrop-filter: blur(12px);
  color: #fff !important;
  border-radius: 0 16px 16px 0;
  animation: fadeIn 0.4s ease-in-out;
}

.nav-item {
  border-radius: 12px;
  margin: 6px 10px;
  transition: transform 0.25s, background 0.25s;
}

.nav-item:hover {
  background: linear-gradient(90deg, #ff512f, #dd2476);
  transform: translateX(6px) scale(1.05);
  color: #fff !important;
}

.submenu-item {
  padding-left: 36px;
  font-size: 14px;
  opacity: 0.9;
  transition: all 0.25s;
}

.submenu-item:hover {
  color: #ffcc00;
  transform: translateX(8px);
}

.section-title {
  font-size: 14px;
  color: #ffcc00;
  font-weight: 600;
  padding-left: 12px;
}

.mobile-appbar {
  background: transparent !important; /* removes background */
  padding: 0 12px;
  box-shadow: none !important; /* removes shadow */
}

.appbar-logo {
  width: 120px;
  border-radius: 10px;
  transition: transform 0.3s ease;
}

.appbar-logo:hover {
  transform: scale(1.1) rotate(-2deg);
}

/* Fade-in animation for drawer */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-40px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.full-width-drawer {
  width: 100vw !important; /* Ensures it covers the entire viewport width */
  max-width: 100vw !important;
  left: 0 !important; /* Aligns to left edge */
  right: 0 !important;
}
</style>
<!-- aug8 -->

// nov 6 2025
